import { render, staticRenderFns } from "./PaginationBlock.vue?vue&type=template&id=66da3c0c"
import script from "./PaginationBlock.vue?vue&type=script&lang=js"
export * from "./PaginationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports